
        
const main = async(UX) => {
    const $mathjax = Array.prototype.slice.call(document.querySelectorAll('body')),
        $componentCollapser = Array.prototype.slice.call(document.getElementsByClassName('js--collapsable')),
        $article = Array.prototype.slice.call(document.getElementsByClassName('tos-list__body')),
        $toggleTable = Array.prototype.slice.call(document.getElementsByClassName('expandable')),
        $progressBar = Array.prototype.slice.call(document.getElementsByClassName('progress-bar')),
        $axelPublicationContent = document.querySelector('.core-collateral'),
        $alertInfo = Array.prototype.slice.call(document.getElementsByClassName('register__alerts')),
        $collapsibleMenu = Array.prototype.slice.call(document.querySelectorAll('[data-collapsible-id]')),
        $loi = Array.prototype.slice.call(document.getElementsByClassName('loi__banner')),
        $listOfIssuesAccordion = Array.prototype.slice.call(document.querySelectorAll('.loi-accordion, .loi-accordion__nested')),
        $connectProfileMenu = document.querySelector('.connect-profile'),
        $cookiePolicyPopupWidget = Array.prototype.slice.call(document.getElementsByClassName('cookiePolicy-popup')),
        $showRecommended = Array.prototype.slice.call(document.getElementsByClassName('show-recommended-placeholder')),
        $examCertificate = Array.prototype.slice.call(document.getElementsByClassName('exam-certificate-message')),
        $disableAdblocker = document.getElementById('DisableAdBlocker'),
        $tfa = Array.prototype.slice.call(document.getElementsByClassName('two-factor-authentication')),
        $slideshow = document.querySelector('.owl-carousel, .js-showcase-slideshow'),
        $profile = document.querySelector('.kbart-token_table, .favoriteShortlist, .profile-menu, .institutionList, .js__removeAdmins, .admin-manage-alerts, .trusted-proxy-form, #institutionUsageReport, .alerts, #institutionUsageReport, #holdingsForm'),
        $pd = document.querySelector('.datepicker, .js-editable, .js-counter, .sortable-table, .client-pagination, .autosave-form, .pd-pdf, .pd-action-bar, .submission-authors, .basic-metadata, .funders, .draftForm, .taxonomies-input-group, .submission-list, .supplemental-files, .supplemental-links, .author-index, .authorsHistoryWidget, .advisorActionRecords'),
        $search = document.querySelector('.facet, .refineSearch,.advanced-search, .range-slider, .facetDateChart, .advanced-search, .search-result')
let promiseVariable = {};
try {
        if ($mathjax.length) { 
            promiseVariable.mathjaxPromise = await import (
    /* webpackChunkName: "mathjax" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/js/plugins/mathjax'
)

const { default: Mathjax } = await promiseVariable.mathjaxPromise
UX.mathjax = new Mathjax($mathjax)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($componentCollapser.length) { 
            promiseVariable.componentCollapserPromise = await import (
    /* webpackChunkName: "componentCollapser" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/node_modules/ui-theme/js/components/_component-collapser'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($article.length) { 
            promiseVariable.articlePromise = await import (
    /* webpackChunkName: "article" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/node_modules/ui-theme/js/components/article'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($toggleTable.length) { 
            promiseVariable.toggleTablePromise = await import (
    /* webpackChunkName: "toggleTable" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/node_modules/ui-core/components/tables/js/tables'
)


UX.toggleTable.init($toggleTable);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($progressBar.length) { 
            promiseVariable.progressBarPromise = await import (
    /* webpackChunkName: "progressBar" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/node_modules/ui-core/components/progress-bar/js/progress-bar'
)


UX.progressBar.init($progressBar);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($axelPublicationContent) { 
            promiseVariable.axelPublicationContentPromise = await import (
    /* webpackChunkName: "axel-publication-content" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/js/widgets/axel-publication-content/axel-publication-content'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($alertInfo.length) { 
            promiseVariable.alertInfoPromise = await import (
    /* webpackChunkName: "alertInfo" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/js/widgets/_alert-information'
)


UX.alertInfo.init($alertInfo);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($collapsibleMenu.length) { 
            promiseVariable.collapsibleMenuPromise = await import (
    /* webpackChunkName: "collapsible-menu" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/js/widgets/_collapsible-menu'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($loi.length) { 
            promiseVariable.loiPromise = await import (
    /* webpackChunkName: "loi" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/node_modules/ui-theme/js/widgets/_loi'
)


UX.loi.init($loi);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($listOfIssuesAccordion.length) { 
            promiseVariable.listOfIssuesAccordionPromise = await import (
    /* webpackChunkName: "listOfIssuesAccordion" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/node_modules/ui-core/widgets/list-of-issues-detailed/js/list-of-issues-accordion'
)


UX.listOfIssuesAccordion.init($listOfIssuesAccordion);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($connectProfileMenu) { 
            promiseVariable.connectProfileMenuPromise = await import (
    /* webpackChunkName: "connectProfileMenu" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/node_modules/ui-core/widgets/connect-profile-menu/js/connect-profile-menu'
)

const { default: ConnectProfileMenu } = await promiseVariable.connectProfileMenuPromise
UX.connectProfileMenu = new ConnectProfileMenu($connectProfileMenu).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($cookiePolicyPopupWidget.length) { 
            promiseVariable.cookiePolicyPopupWidgetPromise = await import (
    /* webpackChunkName: "cookiePolicyPopupWidget" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/node_modules/ui-core/widgets/cookie-policy-popup/js/cookie-policy-popup'
)


UX.cookiePolicyPopupWidget.init($cookiePolicyPopupWidget);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($showRecommended.length) { 
            promiseVariable.showRecommendedPromise = await import (
    /* webpackChunkName: "showRecommended" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/js/widgets/_show-recommended'
)


UX.showRecommended.init($showRecommended);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($examCertificate.length) { 
            promiseVariable.examCertificatePromise = await import (
    /* webpackChunkName: "examCertificate" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/node_modules/ui-core/widgets/exam-certificate/js/exam-certificate'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($disableAdblocker) { 
            promiseVariable.disableAdblockerPromise = await import (
    /* webpackChunkName: "disableAdblocker" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/node_modules/ui-core/widgets/disable-adblocker/js/disable-adblocker'
)

        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($tfa.length) { 
            promiseVariable.tfaPromise = await import (
    /* webpackChunkName: "tfa" */ 
    '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/siam/node_modules/ui-core/widgets/two-factor-authentication/js/two-factor-authentication'
)


UX.tfa.init($tfa);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($slideshow) { 
            promiseVariable.slideshowPromise = await import (
    /* webpackChunkName: "slideshow" */ 
    './groups/_slideshow'
)

const { default: slideshowMain } = await promiseVariable.slideshowPromise
slideshowMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($profile) { 
            promiseVariable.profilePromise = await import (
    /* webpackChunkName: "profile" */ 
    './groups/_profile'
)

const { default: profileMain } = await promiseVariable.profilePromise
profileMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($pd) { 
            promiseVariable.pdPromise = await import (
    /* webpackChunkName: "pd" */ 
    './groups/_pd'
)

const { default: pdMain } = await promiseVariable.pdPromise
pdMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($search) { 
            promiseVariable.searchPromise = await (async () => {
    await Promise.all([promiseVariable.truncatePromise].filter(promise => !!promise));
    return await import (
    /* webpackChunkName: "search" */ 
    './groups/_search'
)
;
})();
const { default: searchMain } = await promiseVariable.searchPromise
searchMain(UX)
        }
    } catch (err) {
        console.error(err);
    }
    
return promiseVariable
}


        export default main;
        